export class VerificationOutcome {
  statusReason: string;
  additionalDetails?: string;
  blockingReversalExempt?: boolean;
  ceReviewNote?: string;
}
